<template>
  <nav
    v-if="!isInFrame()"
    class="header-nav-kids"
    :class="{ 'header-nav-kids--panel': panel }"
  >
    <ul class="header-nav-kids__list">
      <li
        v-if="!panel"
        class="header-nav-kids__brand"
      >
        <router-link
          :to="{ name: '/home' }"
          class="header-nav-kids__logos"
        >
          <img
            src="/svg/logo.svg"
            alt="AfterSchoolVote"
            class="header-nav-kids__logo"
          />
        </router-link>
      </li>
      <li
        v-for="link in links"
        :key="link.routeName"
        class="header-nav-kids__item"
      >
        <router-link
          class="header-nav-link"
          :class="{ 'header-nav-link--active': $route.name === link.routeName }"
          :to="{ name: link.routeName }"
        >
          {{ $t(link.title) }}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { isInFrame } from "@academy/utils"

defineProps({
  panel: {
    type: Boolean,
    default: false,
  },
})

const links = [
  {
    title: "for-schools-page.title",
    routeName: "/for-schools",
  },
  {
    title: "for-families-page.title",
    routeName: "/for-families",
  },
  {
    title: "for-providers-page.title",
    routeName: "/for-providers",
  },
  {
    title: "common.programs",
    routeName: "/programs",
  },
  {
    title: "common.about-us",
    routeName: "/about",
  },
]
</script>

<style lang="scss" scoped>
.header-nav-kids {
  min-width: 0;

  &__list {
    display: flex;
    align-items: center;
    gap: 0 36px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__list > li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    flex-shrink: 0;
  }

  &__brand {
    width: auto;
    margin-right: 16px;
  }

  &__logos {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
  }

  &__logo {
    display: block;
    height: 55px;
    width: auto;
    max-height: 55px;
    object-fit: contain;
  }

  &__list :deep(.header-nav-link) {
    justify-content: center;
    width: auto;
    height: auto;
    min-height: 32px;
    padding: 0 8px;
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;
  }
}

@media (max-width: 1279px) and (min-width: 1024px) {
  .header-nav-kids__list {
    gap: 0 28px;
  }

  .header-nav-kids__brand {
    margin-right: 8px;
  }
}

.header-nav-kids--panel {
  width: 100%;

  .header-nav-kids__list {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }

  .header-nav-kids__list > li {
    width: 100%;
    justify-content: flex-start;
  }

  .header-nav-kids__list :deep(.header-nav-link) {
    width: 100%;
    min-height: 44px;
    padding: 0;
    justify-content: flex-start;
    font-family: Fredoka, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
    color: #17263f;
    text-align: left;
  }
}

@media (max-width: 1023px) {
  .header-nav-kids:not(.header-nav-kids--panel) {
    .header-nav-kids__list {
      gap: 0;
    }

    .header-nav-kids__brand {
      margin-right: 0;
    }

    .header-nav-kids__item {
      display: none;
    }
  }
}
</style>
